import type { ObjectId } from '@racemap/sdk/schema/base';
import type { StripeProducts } from '@racemap/sdk/schema/billing/StripeProducts';
import { useMemo } from 'react';
import {
  getProductPriceFactory,
  type Price,
} from '../../components/CostCalculator/getProductPriceFactory';
import { usePriceList } from './usePriceList';

export function useGetProductPrice({
  userId,
  isReseller,
}: {
  userId?: ObjectId | string;
  isReseller?: boolean;
} = {}): ((product: StripeProducts, quantity: number, tier?: number | null) => Price) | undefined {
  const { priceList } = usePriceList({ userId, isReseller });
  return useMemo(() => getProductPriceFactory(priceList), [priceList]);
}
